// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useLoader } from "../../../../context/LoaderProvider.jsx";
// const Vedioadvertisments = () => {
//     const [formData, setFormData] = useState({
//         type: "",
//         description: "",

//         gole
//             : "",
//         startDate: "",
//         endDate: "",
//         discount: "",
//         image: "",
//     });

//     const [couponRequests, setCouponRequests] = useState([]);
//     const [showModal, setShowModal] = useState(false);
//     const isMobile = window.innerWidth <= 768;
//     const [payNowModal, setPayNowModal] = useState(false);
//     const [selectedAmount, setSelectedAmount] = useState(0);
//     const { showLoader, hideLoader } = useLoader();

//     const [loading, setLoading] = useState(true);

//     const tdStyle = {
//         border: "1px solid #ccc",
//         padding: "10px",
//         textAlign: "left",
//     };


//     const [payNowAmount, setPayNowAmount] = useState(0);
//     const [loadingPayNow, setLoadingPayNow] = useState(false);
//     const [selectedCouponId, setSelectedCouponId] = useState(null);


//     const handleRazorpayPayment = async () => {
//         if (!selectedCouponId) {
//             alert("No coupon selected for payment.");
//             return;
//         }

//         try {
//             const vendorId = localStorage.getItem("vendorId");
//             const token = localStorage.getItem("authToken");
//             if (!vendorId || !token) {
//                 alert("Vendor session expired. Please login again.");
//                 return;
//             }

//             const amountInPaise = Math.round(payNowAmount); // convert INR to paise

//             // Step 0: Fetch vendor details for prefill info
//             const { data: vendorData } = await axios.get(
//                 `https://backend.maamaas.com/food/api/vendors/${vendorId}`,
//                 { headers: { Authorization: `Bearer ${token}` } }
//             );

//             const vendorMobile = vendorData?.mobileNumber || "9999999999";
//             const vendorName = vendorData?.ownerName || "Vendor";
//             const vendorEmail = vendorData?.email || "vendor@example.com";

//             // Step 1: Create Razorpay order via backend
//             const username = "rzp_live_RU5whSMu9rPV7s"; // Razorpay key
//             const password = "khRC0vtSHCGHktyu62yekZp0"; // Razorpay secret
//             const basicAuth = btoa(`${username}:${password}`);

//             showLoader();
//             const { data: orderData } = await axios.post(
//                 "https://backend.maamaas.com/subscription/api/user/create-order",
//                 { amount: amountInPaise, currency: "INR", vendorId },
//                 { headers: { Authorization: `Basic ${basicAuth}` } }
//             );

//             if (!orderData.orderId) throw new Error("Order ID not received");

//             // Step 2: Open Razorpay checkout
//             const rzp = new window.Razorpay({
//                 key: username,
//                 amount: amountInPaise,
//                 currency: "INR",
//                 name: "Maamaa's",
//                 description: "Coupon Payment",
//                 order_id: orderData.orderId,
//                 handler: async (response) => {
//                     try {
//                         const { razorpay_payment_id, razorpay_order_id } = response;
//                         if (!razorpay_payment_id || !razorpay_order_id)
//                             throw new Error("Payment ID or Order ID missing");

//                         // Step 3: Capture payment via backend
//                         await axios.post(
//                             "https://backend.maamaas.com/subscription/api/user/capture",
//                             {
//                                 paymentId: razorpay_payment_id,
//                                 amount: amountInPaise,
//                                 currency: "INR",
//                                 vendorId,
//                             },
//                             { headers: { Authorization: `Basic ${basicAuth}` } }
//                         );

//                         // Step 4: Update advertisement/payment info
//                         await axios.put(
//                             `https://backend.maamaas.com/food/api/vendor/advertisements/update-payment/${selectedCouponId}`,
//                             {},
//                             {
//                                 params: {
//                                     vendorRequirementCouponId: selectedCouponId,
//                                     transactionId: razorpay_payment_id,
//                                     orderId: razorpay_order_id,
//                                 },
//                                 headers: { Authorization: `Bearer ${token}` },
//                             }
//                         );

//                         alert("Payment successful and updated!");
//                         window.location.reload();
//                         setPayNowModal(false);
//                     } catch (err) {
//                         console.error("❌ Payment handling error:", err);
//                         alert("Payment succeeded but update failed. Check console.");
//                     }
//                 },
//                 prefill: {
//                     name: vendorName,
//                     email: vendorEmail,
//                     contact: vendorMobile, // ✅ dynamic mobile number from backend
//                 },
//                 theme: { color: "#b15cd6" },
//             });

//             rzp.open();
//         } catch (err) {
//             console.error("❌ Razorpay initialization failed:", err);
//             alert("Payment initialization failed.");
//         } finally {
//             hideLoader();
//         }
//     };



//     const openPayNowModal = async (couponId) => {
//         try {
//             setLoadingPayNow(true);
//             const token = localStorage.getItem("authToken");
//             showLoader();

//             const response = await axios.get(
//                 `https://backend.maamaas.com/food/api/vendor/advertisements/get/${couponId}`,
//                 { headers: { Authorization: `Bearer ${token}` } }
//             );

//             setPayNowAmount(response.data.amount || 0);
//             setSelectedCouponId(couponId); // ✅ save for payment update /api/vendor/advertisements/add/{vendorId}  /api/vendor/advertisements/get/{id}
//             setPayNowModal(true);
//         } catch (error) {
//             console.error("❌ Error fetching coupon amount:", error);
//             alert("Failed to fetch coupon amount");
//         } finally {
//             setLoadingPayNow(false);
//             hideLoader();
//         }
//     };


//     useEffect(() => {
//         const fetchCoupons = async () => {
//             try {
//                 const token = localStorage.getItem("authToken");
//                 const vendorId = localStorage.getItem("vendorId");
//                 showLoader();
//                 if (!token || !vendorId) {
//                     alert("Missing vendor session. Please log in again.");
//                     setLoading(false);
//                     return;
//                 }

//                 const response = await axios.get(
//                     `https://backend.maamaas.com/food/api/advertisements/getby/${vendorId}`,
//                     {
//                         headers: { Authorization: `Bearer ${token}` }
//                     }
//                 );

//                 // Wrap single object in array
//                 const couponsArray = Array.isArray(response.data) ? response.data : [response.data];
//                 setCouponRequests(couponsArray);

//             } catch (error) {
//                 console.error("❌ Error fetching coupons:", error);
//                 alert("Failed to fetch coupon requests");
//             } finally {
//                 setLoading(false);
//                 hideLoader();
//             }
//         };

//         fetchCoupons();
//     }, []);



//     const handleChange = (e) => {
//         setFormData({ ...formData, [e.target.name]: e.target.value });
//     };



//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         try {
//             const token = localStorage.getItem("authToken");
//             const vendorId = localStorage.getItem("vendorId");
//             showLoader();
//             if (!token || !vendorId) {
//                 alert("Missing vendor session. Please log in again.");
//                 return;
//             }

//             const advertisementData = {
//                 advertisementId: 0,
//                 title: formData.title || "Default Title",
//                 type: formData.mediaFile
//                     ? formData.mediaFile.type.startsWith("video") ? "VIDEO" : "IMAGE"
//                     : "TEXT",
//                 description: formData.description || "",
//                 startDate: formData.startDate ? new Date(formData.startDate).toISOString() : null,
//                 endDate: formData.endDate ? new Date(formData.endDate).toISOString() : null,
//                 amount: 0,
//                 vendorId: Number(vendorId),
//                 paymentStatus: "PENDING",
//                 transactionId: "string",
//                 orderId: "string",
//             };

//             const fd = new FormData();
//             fd.append(
//                 "advertisementData",
//                 new Blob([JSON.stringify(advertisementData)], { type: "application/json" })
//             );

//             if (formData.mediaFile) {
//                 fd.append("mediaFile", formData.mediaFile, formData.mediaFile.name);
//             }

//             // Preview data being sent
//             let formEntries = "Data being sent:\n";
//             for (let [key, value] of fd.entries()) {
//                 if (value instanceof File) {
//                     formEntries += `${key}: ${value.name} (${value.type}, ${value.size} bytes)\n`;
//                 } else {
//                     formEntries += `${key}: ${value}\n`;
//                 }
//             }
//             // alert(formEntries);

//             const response = await axios.post(
//                 `https://backend.maamaas.com/food/api/vendor/advertisements/add/${vendorId}`,
//                 fd,
//                 {
//                     headers: {
//                         "Content-Type": "multipart/form-data",
//                         Authorization: `Bearer ${token}`,
//                     },
//                 }
//             );

//             setCouponRequests(prev => [...prev, response.data]);
//             alert("Advertisement submitted successfully!");
//             window.location.reload();
//             setFormData({
//                 title: "",
//                 description: "",
//                 startDate: "",
//                 endDate: "",
//                 mediaFile: null,
//             });
//             setShowModal(false);

//         } catch (error) {
//             console.error("❌ Error submitting advertisement:", error.response?.data || error.message);
//             alert("Failed to submit advertisement.\nCheck console for details.");
//         } finally {
//             hideLoader();
//         }
//     };


//     return (
//         <div
//             style={{
//                 // padding: '20px',
//                 maxWidth: '1200px',
//                 // margin: isMobile ? '0px' : 'auto',
//                 boxSizing: 'border-box',
//                 position: 'relative',
//                 width: '100%',
//                 marginTop: isMobile ? '20px' : 'auto',
//             }}
//         >
//             <div style={{
//                 display: 'flex',
//                 justifyContent: 'space-between',
//                 alignItems: 'center',
//                 marginBottom: '0px'
//             }}>
//                 <button
//                     style={{
//                         padding: '10px 16px',
//                         backgroundColor: '#1976d2',
//                         color: '#fff',
//                         border: 'none',
//                         borderRadius: '6px',
//                         cursor: 'pointer',
//                         fontWeight: 'bold',
//                         fontSize: 'clamp(12px, 2vw, 14px)',
//                     }}
//                     onClick={() => setShowModal(true)}
//                 >
//                     + Request Add
//                 </button>
//             </div>

//             {/* Table Section */}
//             <div style={{
//                 marginTop: '0px',
//                 overflowX: 'auto',   // Horizontal scroll
//                 overflowY: 'auto',   // Vertical scroll
//                 width: '100%',
//                 height: '60vh',
//                 scrollbarWidth: 'thin', // For Firefox
//                 msOverflowStyle: 'auto', // For IE/Edge
//             }}
//             >
//                 <div style={{
//                     minWidth: '800px',
//                     width: '100%'
//                 }}>
//                     <table
//                         style={{
//                             width: "100%",
//                             borderCollapse: "collapse",
//                             backgroundColor: "white",
//                             border: "1px solid #ccc",
//                             marginTop: "0px"
//                         }}
//                     >
//                         <thead>
//                             <tr>
//                                 {[
//                                     "S.No",
//                                     // "Type",
//                                     "Description",
//                                     "Image",
//                                     "Video",
//                                     // "Goal",
//                                     "Start Date",
//                                     "End Date",
//                                     // "Discount",
//                                     "Amount",
//                                     "Status",
//                                     "Action",
//                                 ].map((head, i) => (
//                                     <th
//                                         key={i}
//                                         style={{
//                                             border: "1px solid #ccc",
//                                             padding: "10px",
//                                             backgroundColor: "#b15cd6",
//                                             fontSize: "clamp(10px, 2vw, 14px)",
//                                             textAlign: "center",
//                                             whiteSpace: "nowrap",
//                                         }}
//                                     >
//                                         {head}
//                                     </th>
//                                 ))}
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {loading ? (
//                                 <tr>
//                                     <td colSpan="9" style={{ textAlign: "center", padding: "12px" }}>Loading...</td>
//                                 </tr>
//                             ) : couponRequests.length === 0 ? (
//                                 <tr>
//                                     <td colSpan="9" style={{ textAlign: "center", padding: "12px" }}>No requests yet.</td>
//                                 </tr>
//                             ) : (
//                                 couponRequests.map((request, index) => (
//                                     <tr key={index}>
//                                         <td style={tdStyle}>{index + 1}</td>
//                                         <td style={tdStyle}>{request.description || "-"}</td>
//                                         <td style={tdStyle}>
//                                             {request.mediaUrl && request.type === "IMAGE" ? (
//                                                 <img
//                                                     src={request.mediaUrl}
//                                                     alt="Image"
//                                                     style={{ width: "60px", height: "60px", objectFit: "cover", borderRadius: "6px", border: "1px solid #ccc" }}
//                                                 />
//                                             ) : "No Image"}
//                                         </td>
//                                         <td style={tdStyle}>
//                                             {request.mediaUrl && request.type === "VIDEO" ? (
//                                                 <video width="100" height="60" controls style={{ borderRadius: "6px", border: "1px solid #ccc" }}>
//                                                     <source src={request.mediaUrl} type="video/mp4" />
//                                                     Your browser does not support the video tag.
//                                                 </video>
//                                             ) : "No Video"}
//                                         </td>
//                                         <td style={tdStyle}>{request.startDate ? new Date(request.startDate).toLocaleDateString("en-GB") : "-"}</td>
//                                         <td style={tdStyle}>{request.endDate ? new Date(request.endDate).toLocaleDateString("en-GB") : "-"}</td>
//                                         <td style={tdStyle}>{request.amount || "-"}</td>
//                                         <td style={tdStyle}>{request.paymentStatus || "Pending"}</td>
//                                         <td style={tdStyle}>
//                                             {request.paymentStatus === "PAID" ? (
//                                                 <button disabled style={{ backgroundColor: "gray", color: "white", borderRadius: "6px" }}>Paid</button>
//                                             ) : (
//                                                 <button
//                                                     style={{ backgroundColor: "#b15cd6", color: "white", borderRadius: "6px" }}
//                                                     onClick={() => openPayNowModal(request.advertisementId)}
//                                                 >
//                                                     Pay Now
//                                                 </button>
//                                             )}
//                                         </td>
//                                     </tr>
//                                 ))
//                             )}
//                         </tbody>

//                     </table>
//                 </div>
//             </div>


//             {payNowModal && (
//                 <div
//                     style={{
//                         position: 'fixed',
//                         top: 0,
//                         left: 0,
//                         height: '100vh',
//                         width: '100vw',
//                         backgroundColor: 'rgba(0,0,0,0.5)',
//                         display: 'flex',
//                         justifyContent: 'center',
//                         alignItems: 'center',
//                         zIndex: 1000,
//                     }}
//                 >
//                     <div
//                         style={{
//                             backgroundColor: '#fff',
//                             padding: '20px',
//                             borderRadius: '10px',
//                             width: '90%',
//                             maxWidth: '400px',
//                             boxSizing: 'border-box',
//                         }}
//                     >
//                         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                             <h3 style={{ fontSize: 'clamp(16px, 3vw, 20px)', fontWeight: 'bold' }}>Pay Now</h3>
//                             <button
//                                 style={{
//                                     background: 'transparent',
//                                     border: 'none',
//                                     fontSize: '18px',
//                                     cursor: 'pointer',
//                                 }}
//                                 onClick={() => setPayNowModal(false)}
//                             >
//                                 ✕
//                             </button>
//                         </div>

//                         <div style={{ marginTop: '16px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
//                             {loadingPayNow ? (
//                                 <p>Loading amount...</p>
//                             ) : (
//                                 <label style={labelStyle}>
//                                     Amount
//                                     <input
//                                         type="number"
//                                         value={payNowAmount}
//                                         readOnly
//                                         style={{ ...inputStyle, fontSize: 'clamp(12px, 2vw, 14px)' }}
//                                     />
//                                 </label>
//                             )}

//                             <button
//                                 style={{
//                                     padding: '12px',
//                                     backgroundColor: '#1976d2',
//                                     color: 'white',
//                                     fontWeight: 'bold',
//                                     border: 'none',
//                                     borderRadius: '6px',
//                                     cursor: 'pointer',
//                                     width: 'fit-content',
//                                     fontSize: 'clamp(12px, 2vw, 14px)'
//                                 }}
//                                 onClick={handleRazorpayPayment} // ✅ call payment function
//                             >
//                                 Proceed to Pay
//                             </button>

//                         </div>
//                     </div>
//                 </div>
//             )}



//             {/* Modal Popup */}
//             {showModal && (
//                 <div
//                     style={{
//                         position: 'fixed',
//                         top: 0,
//                         left: 0,
//                         height: '100vh',
//                         width: '100vw',
//                         backgroundColor: 'rgba(0,0,0,0.5)',
//                         display: 'flex',
//                         justifyContent: 'center',
//                         alignItems: 'center',
//                         zIndex: 1000,
//                     }}
//                 >
//                     <div
//                         style={{
//                             backgroundColor: '#fff',
//                             padding: '20px',
//                             borderRadius: '10px',
//                             width: '90%',
//                             maxWidth: '600px',
//                             maxHeight: '90vh',
//                             overflowY: 'auto',
//                             boxSizing: 'border-box',
//                         }}
//                     >
//                         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                             <h3 style={{ fontSize: 'clamp(16px, 3vw, 20px)', fontWeight: 'bold' }}>Request For Advertisement</h3>
//                             <button
//                                 style={{
//                                     background: 'transparent',
//                                     border: 'none',
//                                     fontSize: '18px',
//                                     cursor: 'pointer',
//                                 }}
//                                 onClick={() => setShowModal(false)}
//                             >
//                                 ✕
//                             </button>
//                         </div>

//                         <form onSubmit={handleSubmit} style={{
//                             display: 'flex',
//                             flexDirection: 'column',
//                             gap: '12px',
//                             marginTop: '16px'
//                         }}>

//                             <textarea
//                                 name="description"
//                                 placeholder="Description"
//                                 value={formData.description}
//                                 onChange={handleChange}
//                                 rows="3"
//                                 required
//                                 style={{ ...inputStyle, resize: 'vertical', fontSize: 'clamp(12px, 2vw, 14px)' }}
//                             />

//                             <div style={{
//                                 display: 'flex',
//                                 flexDirection: window.innerWidth < 480 ? 'column' : 'row',
//                                 gap: '12px'
//                             }}>
//                                 <div style={{ flex: 1 }}>
//                                     <label style={labelStyle}>
//                                         Start Date
//                                         <input
//                                             type="date"
//                                             name="startDate"
//                                             value={formData.startDate}
//                                             onChange={handleChange}
//                                             min={new Date().toISOString().split('T')[0]}

//                                             required
//                                             style={{ ...inputStyle, fontSize: 'clamp(12px, 2vw, 14px)' }}
//                                         />
//                                     </label>
//                                 </div>
//                                 <div style={{ flex: 1 }}>
//                                     <label style={labelStyle}>
//                                         End Date
//                                         <input
//                                             type="date"
//                                             name="endDate"
//                                             value={formData.endDate}
//                                             onChange={handleChange}
//                                             min={formData.startDate || new Date().toISOString().split('T')[0]}

//                                             required
//                                             style={{ ...inputStyle, fontSize: 'clamp(12px, 2vw, 14px)' }}
//                                         />
//                                     </label>
//                                 </div>
//                             </div>


//                             <input
//                                 type="file"
//                                 accept="image/*,video/*" // accept both image and video
//                                 onChange={(e) => {
//                                     const file = e.target.files[0];
//                                     if (!file) return;
//                                     setFormData(prev => ({ ...prev, mediaFile: file }));
//                                 }}
//                                 style={{ ...inputStyle, fontSize: 'clamp(12px, 2vw, 14px)' }}
//                             />


//                             <button
//                                 type="submit"
//                                 style={{
//                                     padding: '12px',
//                                     backgroundColor: '#1976d2',
//                                     color: 'white',
//                                     fontWeight: 'bold',
//                                     border: 'none',
//                                     borderRadius: '6px',
//                                     cursor: 'pointer',
//                                     width: 'fit-content',
//                                     fontSize: 'clamp(12px, 2vw, 14px)'
//                                 }}
//                             >
//                                 Submit Request
//                             </button>
//                         </form>
//                     </div>
//                 </div>
//             )}

//         </div>
//     );
// };

// // Reusable styles
// const inputStyle = {
//     padding: '10px',
//     border: '1px solid #ccc',
//     borderRadius: '6px',
//     width: '100%',
//     boxSizing: 'border-box',
// };

// const labelStyle = {
//     fontSize: 'clamp(12px, 2vw, 14px)',
//     marginBottom: '4px',
//     display: 'block',
// };

// const tdStyle = {
//     padding: '10px',
//     border: '1px solid #ccc',
//     textAlign: 'left',
// };

// export default Vedioadvertisments;



import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLoader } from "../../../../context/LoaderProvider.jsx";

const Vedioadvertisments = () => {
    const [formData, setFormData] = useState({
        title: "",
        description: "",
        resolution: "HORIZONTAL", // Default value
        startDate: "",
        endDate: "",
        mediaFile: null,
    });

    const [couponRequests, setCouponRequests] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const isMobile = window.innerWidth <= 768;
    const [payNowModal, setPayNowModal] = useState(false);
    const { showLoader, hideLoader } = useLoader();
    const [loading, setLoading] = useState(true);
    const [payNowAmount, setPayNowAmount] = useState(0);
    const [loadingPayNow, setLoadingPayNow] = useState(false);
    const [selectedCouponId, setSelectedCouponId] = useState(null);

    const tdStyle = {
        border: "1px solid #ccc",
        padding: "10px",
        textAlign: "left",
    };

    const handleRazorpayPayment = async () => {
        if (!selectedCouponId) {
            alert("No coupon selected for payment.");
            return;
        }

        try {
            const vendorId = localStorage.getItem("vendorId");
            const token = localStorage.getItem("authToken");
            if (!vendorId || !token) {
                alert("Vendor session expired. Please login again.");
                return;
            }

            const amountInPaise = Math.round(payNowAmount);

            const { data: vendorData } = await axios.get(
                `https://backend.maamaas.com/food/api/vendors/${vendorId}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            const vendorMobile = vendorData?.mobileNumber || "9999999999";
            const vendorName = vendorData?.ownerName || "Vendor";
            const vendorEmail = vendorData?.email || "vendor@example.com";

            const username = "rzp_live_RU5whSMu9rPV7s";
            const password = "khRC0vtSHCGHktyu62yekZp0";
            const basicAuth = btoa(`${username}:${password}`);

            showLoader();
            const { data: orderData } = await axios.post(
                "https://backend.maamaas.com/subscription/api/user/create-order",
                { amount: amountInPaise, currency: "INR", vendorId },
                { headers: { Authorization: `Basic ${basicAuth}` } }
            );

            if (!orderData.orderId) throw new Error("Order ID not received");

            const rzp = new window.Razorpay({
                key: username,
                amount: amountInPaise,
                currency: "INR",
                name: "Maamaa's",
                description: "Coupon Payment",
                order_id: orderData.orderId,
                handler: async (response) => {
                    try {
                        const { razorpay_payment_id, razorpay_order_id } = response;
                        if (!razorpay_payment_id || !razorpay_order_id)
                            throw new Error("Payment ID or Order ID missing");

                        await axios.post(
                            "https://backend.maamaas.com/subscription/api/user/capture",
                            {
                                paymentId: razorpay_payment_id,
                                amount: amountInPaise,
                                currency: "INR",
                                vendorId,
                            },
                            { headers: { Authorization: `Basic ${basicAuth}` } }
                        );

                        await axios.put(
                            `https://backend.maamaas.com/food/api/vendor/advertisements/update-payment/${selectedCouponId}`,
                            {},
                            {
                                params: {
                                    vendorRequirementCouponId: selectedCouponId,
                                    transactionId: razorpay_payment_id,
                                    orderId: razorpay_order_id,
                                },
                                headers: { Authorization: `Bearer ${token}` },
                            }
                        );

                        alert("Payment successful and updated!");
                        window.location.reload();
                        setPayNowModal(false);
                    } catch (err) {
                        console.error("❌ Payment handling error:", err);
                        alert("Payment succeeded but update failed. Check console.");
                    }
                },
                prefill: {
                    name: vendorName,
                    email: vendorEmail,
                    contact: vendorMobile,
                },
                theme: { color: "#b15cd6" },
            });

            rzp.open();
        } catch (err) {
            console.error("❌ Razorpay initialization failed:", err);
            alert("Payment initialization failed.");
        } finally {
            hideLoader();
        }
    };

    const openPayNowModal = async (couponId) => {
        try {
            setLoadingPayNow(true);
            const token = localStorage.getItem("authToken");
            showLoader();

            const response = await axios.get(
                `https://backend.maamaas.com/food/api/vendor/advertisements/get/${couponId}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            setPayNowAmount(response.data.amount || 0);
            setSelectedCouponId(couponId);
            setPayNowModal(true);
        } catch (error) {
            console.error("❌ Error fetching coupon amount:", error);
            alert("Failed to fetch coupon amount");
        } finally {
            setLoadingPayNow(false);
            hideLoader();
        }
    };

    useEffect(() => {
        const fetchCoupons = async () => {
            try {
                const token = localStorage.getItem("authToken");
                const vendorId = localStorage.getItem("vendorId");
                showLoader();
                if (!token || !vendorId) {
                    alert("Missing vendor session. Please log in again.");
                    setLoading(false);
                    return;
                }

                const response = await axios.get(
                    `https://backend.maamaas.com/food/api/advertisements/getby/${vendorId}`,
                    {
                        headers: { Authorization: `Bearer ${token}` }
                    }
                );

                const couponsArray = Array.isArray(response.data) ? response.data : [response.data];
                setCouponRequests(couponsArray);

            } catch (error) {
                console.error("❌ Error fetching coupons:", error);
                alert("Failed to fetch coupon requests");
            } finally {
                setLoading(false);
                hideLoader();
            }
        };

        fetchCoupons();
    }, []);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const token = localStorage.getItem("authToken");
            const vendorId = localStorage.getItem("vendorId");
            showLoader();
            if (!token || !vendorId) {
                alert("Missing vendor session. Please log in again.");
                return;
            }

            const advertisementData = {
                advertisementId: 0,
                title: formData.title || "Default Title",
                type: formData.mediaFile
                    ? formData.mediaFile.type.startsWith("video") ? "VIDEO" : "IMAGE"
                    : "TEXT",
                description: formData.description || "",
                resolution: formData.resolution || "HORIZONTAL", // Add resolution to payload
                startDate: formData.startDate ? new Date(formData.startDate).toISOString() : null,
                endDate: formData.endDate ? new Date(formData.endDate).toISOString() : null,
                amount: 0,
                vendorId: Number(vendorId),
                paymentStatus: "PENDING",
                transactionId: "string",
                orderId: "string",
            };

            const fd = new FormData();
            fd.append(
                "advertisementData",
                new Blob([JSON.stringify(advertisementData)], { type: "application/json" })
            );

            if (formData.mediaFile) {
                fd.append("mediaFile", formData.mediaFile, formData.mediaFile.name);
            }

            // Preview data being sent
            let formEntries = "Data being sent:\n";
            for (let [key, value] of fd.entries()) {
                if (value instanceof File) {
                    formEntries += `${key}: ${value.name} (${value.type}, ${value.size} bytes)\n`;
                } else {
                    formEntries += `${key}: ${value}\n`;
                }
            }
            // alert(formEntries);

            const response = await axios.post(
                `https://backend.maamaas.com/food/api/vendor/advertisements/add/${vendorId}`,
                fd,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            setCouponRequests(prev => [...prev, response.data]);
            alert("Advertisement submitted successfully!");
            window.location.reload();
            setFormData({
                title: "",
                description: "",
                resolution: "HORIZONTAL",
                startDate: "",
                endDate: "",
                mediaFile: null,
            });
            setShowModal(false);

        } catch (error) {
            console.error("❌ Error submitting advertisement:", error.response?.data || error.message);
            alert("Failed to submit advertisement.\nCheck console for details.");
        } finally {
            hideLoader();
        }
    };

    return (
        <div
            style={{
                maxWidth: '1200px',
                width: '100%',
                marginTop: isMobile ? '20px' : 'auto',
            }}
        >
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '10px'
            }}>
                <button
                    style={{
                        padding: '10px 16px',
                        backgroundColor: '#1976d2',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        fontWeight: 'bold',
                        fontSize: 'clamp(12px, 2vw, 14px)',
                    }}
                    onClick={() => setShowModal(true)}
                >
                    + Request Add
                </button>
            </div>

            {/* Table Section */}
            <div style={{
                marginTop: '0px',
                overflowX: 'auto',
                overflowY: 'auto',
                width: '100%',
                height: '60vh',
                scrollbarWidth: 'thin',
            }}
            >
                <div style={{
                    minWidth: '900px', // Increased to accommodate new column
                    width: '100%'
                }}>
                    <table
                        style={{
                            width: "100%",
                            borderCollapse: "collapse",
                            backgroundColor: "white",
                            border: "1px solid #ccc",
                            marginTop: "0px"
                        }}
                    >
                        <thead>
                            <tr>
                                {[
                                    "S.No",
                                    "Description",
                                    "Resolution", // New column
                                    "Image",
                                    "Video",
                                    "Start Date",
                                    "End Date",
                                    "Amount",
                                    "Status",
                                    "Action",
                                ].map((head, i) => (
                                    <th
                                        key={i}
                                        style={{
                                            border: "1px solid #ccc",
                                            padding: "10px",
                                            backgroundColor: "#b15cd6",
                                            fontSize: "clamp(10px, 2vw, 14px)",
                                            textAlign: "center",
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        {head}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="10" style={{ textAlign: "center", padding: "12px" }}>Loading...</td>
                                </tr>
                            ) : couponRequests.length === 0 ? (
                                <tr>
                                    <td colSpan="10" style={{ textAlign: "center", padding: "12px" }}>No requests yet.</td>
                                </tr>
                            ) : (
                                couponRequests.map((request, index) => (
                                    <tr key={index}>
                                        <td style={tdStyle}>{index + 1}</td>
                                        <td style={tdStyle}>{request.description || "-"}</td>
                                        <td style={tdStyle}>
                                            {request.resolution === "HORIZONTAL" ? "Horizontal" : 
                                             request.resolution === "VERTICAL" ? "Vertical" : "-"}
                                        </td>
                                        <td style={tdStyle}>
                                            {request.mediaUrl && request.type === "IMAGE" ? (
                                                <img
                                                    src={request.mediaUrl}
                                                    alt="Image"
                                                    style={{ width: "60px", height: "60px", objectFit: "cover", borderRadius: "6px", border: "1px solid #ccc" }}
                                                />
                                            ) : "No Image"}
                                        </td>
                                        <td style={tdStyle}>
                                            {request.mediaUrl && request.type === "VIDEO" ? (
                                                <video width="100" height="60" controls style={{ borderRadius: "6px", border: "1px solid #ccc" }}>
                                                    <source src={request.mediaUrl} type="video/mp4" />
                                                    Your browser does not support the video tag.
                                                </video>
                                            ) : "No Video"}
                                        </td>
                                        <td style={tdStyle}>{request.startDate ? new Date(request.startDate).toLocaleDateString("en-GB") : "-"}</td>
                                        <td style={tdStyle}>{request.endDate ? new Date(request.endDate).toLocaleDateString("en-GB") : "-"}</td>
                                        <td style={tdStyle}>{request.amount || "-"}</td>
                                        <td style={tdStyle}>{request.paymentStatus || "Pending"}</td>
                                        <td style={tdStyle}>
                                            {request.paymentStatus === "PAID" ? (
                                                <button disabled style={{ backgroundColor: "gray", color: "white", borderRadius: "6px" }}>Paid</button>
                                            ) : (
                                                <button
                                                    style={{ backgroundColor: "#b15cd6", color: "white", borderRadius: "6px" }}
                                                    onClick={() => openPayNowModal(request.advertisementId)}
                                                >
                                                    Pay Now
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {payNowModal && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        height: '100vh',
                        width: '100vw',
                        backgroundColor: 'rgba(0,0,0,0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 1000,
                    }}
                >
                    <div
                        style={{
                            backgroundColor: '#fff',
                            padding: '20px',
                            borderRadius: '10px',
                            width: '90%',
                            maxWidth: '400px',
                            boxSizing: 'border-box',
                        }}
                    >
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h3 style={{ fontSize: 'clamp(16px, 3vw, 20px)', fontWeight: 'bold' }}>Pay Now</h3>
                            <button
                                style={{
                                    background: 'transparent',
                                    border: 'none',
                                    fontSize: '18px',
                                    cursor: 'pointer',
                                }}
                                onClick={() => setPayNowModal(false)}
                            >
                                ✕
                            </button>
                        </div>

                        <div style={{ marginTop: '16px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
                            {loadingPayNow ? (
                                <p>Loading amount...</p>
                            ) : (
                                <label style={labelStyle}>
                                    Amount
                                    <input
                                        type="number"
                                        value={payNowAmount}
                                        readOnly
                                        style={{ ...inputStyle, fontSize: 'clamp(12px, 2vw, 14px)' }}
                                    />
                                </label>
                            )}

                            <button
                                style={{
                                    padding: '12px',
                                    backgroundColor: '#1976d2',
                                    color: 'white',
                                    fontWeight: 'bold',
                                    border: 'none',
                                    borderRadius: '6px',
                                    cursor: 'pointer',
                                    width: 'fit-content',
                                    fontSize: 'clamp(12px, 2vw, 14px)'
                                }}
                                onClick={handleRazorpayPayment}
                            >
                                Proceed to Pay
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal Popup */}
            {showModal && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        height: '100vh',
                        width: '100vw',
                        backgroundColor: 'rgba(0,0,0,0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 1000,
                    }}
                >
                    <div
                        style={{
                            backgroundColor: '#fff',
                            padding: '20px',
                            borderRadius: '10px',
                            width: '90%',
                            maxWidth: '600px',
                            maxHeight: '90vh',
                            overflowY: 'auto',
                            boxSizing: 'border-box',
                        }}
                    >
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h3 style={{ fontSize: 'clamp(16px, 3vw, 20px)', fontWeight: 'bold' }}>Request For Advertisement</h3>
                            <button
                                style={{
                                    background: 'transparent',
                                    border: 'none',
                                    fontSize: '18px',
                                    cursor: 'pointer',
                                }}
                                onClick={() => setShowModal(false)}
                            >
                                ✕
                            </button>
                        </div>

                        <form onSubmit={handleSubmit} style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '12px',
                            marginTop: '16px'
                        }}>
                            <textarea
                                name="description"
                                placeholder="Description"
                                value={formData.description}
                                onChange={handleChange}
                                rows="3"
                                required
                                style={{ ...inputStyle, resize: 'vertical', fontSize: 'clamp(12px, 2vw, 14px)' }}
                            />

                            {/* Resolution Radio Buttons */}
                            <div style={{ marginBottom: '10px' }}>
                                <label style={{ ...labelStyle, marginBottom: '8px' }}>Resolution:</label>
                                <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                                    <label style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                        <input
                                            type="radio"
                                            name="resolution"
                                            value="HORIZONTAL"
                                            checked={formData.resolution === "HORIZONTAL"}
                                            onChange={handleChange}
                                            style={{ width: 'auto' }}
                                        />
                                        Horizontal
                                    </label>
                                    <label style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                        <input
                                            type="radio"
                                            name="resolution"
                                            value="VERTICAL"
                                            checked={formData.resolution === "VERTICAL"}
                                            onChange={handleChange}
                                            style={{ width: 'auto' }}
                                        />
                                        Vertical
                                    </label>
                                </div>
                            </div>

                            <div style={{
                                display: 'flex',
                                flexDirection: window.innerWidth < 480 ? 'column' : 'row',
                                gap: '12px'
                            }}>
                                <div style={{ flex: 1 }}>
                                    <label style={labelStyle}>
                                        Start Date
                                        <input
                                            type="date"
                                            name="startDate"
                                            value={formData.startDate}
                                            min={new Date().toISOString().split('T')[0]}
                                            onChange={handleChange}
                                            required
                                            style={{ ...inputStyle, fontSize: 'clamp(12px, 2vw, 14px)' }}
                                        />
                                    </label>
                                </div>
                                <div style={{ flex: 1 }}>
                                    <label style={labelStyle}>
                                        End Date
                                        <input
                                            type="date"
                                            name="endDate"
                                            value={formData.endDate}
                                            onChange={handleChange}
                                            min={formData.startDate || new Date().toISOString().split('T')[0]}
                                            required
                                            style={{ ...inputStyle, fontSize: 'clamp(12px, 2vw, 14px)' }}
                                        />
                                    </label>
                                </div>
                            </div>

                            <input
                                type="file"
                                accept="image/*,video/*"
                                onChange={(e) => {
                                    const file = e.target.files[0];
                                    if (!file) return;
                                    setFormData(prev => ({ ...prev, mediaFile: file }));
                                }}
                                style={{ ...inputStyle, fontSize: 'clamp(12px, 2vw, 14px)' }}
                            />

                            <button
                                type="submit"
                                style={{
                                    padding: '12px',
                                    backgroundColor: '#1976d2',
                                    color: 'white',
                                    fontWeight: 'bold',
                                    border: 'none',
                                    borderRadius: '6px',
                                    cursor: 'pointer',
                                    width: 'fit-content',
                                    fontSize: 'clamp(12px, 2vw, 14px)'
                                }}
                            >
                                Submit Request
                            </button>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

// Reusable styles
const inputStyle = {
    padding: '10px',
    border: '1px solid #ccc',
    borderRadius: '6px',
    width: '100%',
    boxSizing: 'border-box',
};

const labelStyle = {
    fontSize: 'clamp(12px, 2vw, 14px)',
    marginBottom: '4px',
    display: 'block',
};

export default Vedioadvertisments;